import { collection, documentId, getDocs, query, where } from 'firebase/firestore';

import { db } from '../../firebase';

const PREMIUM_SUBSCRIPTION_STATUSES = new Set(['active', 'expiring']);
const MAX_DOCUMENT_IDS_PER_QUERY = 30;

const chunkList = (items, chunkSize) => {
  const chunks = [];

  for (let index = 0; index < items.length; index += chunkSize) {
    chunks.push(items.slice(index, index + chunkSize));
  }

  return chunks;
};

export const getPremiumSubscriberUserIds = async (userIds = []) => {
  const uniqueUserIds = [...new Set(userIds.filter(Boolean))];

  if (!uniqueUserIds.length) {
    return new Set();
  }

  const premiumUserIds = new Set();
  const userIdChunks = chunkList(uniqueUserIds, MAX_DOCUMENT_IDS_PER_QUERY);

  const snapshots = await Promise.all(
    userIdChunks.map((chunk) =>
      getDocs(query(collection(db, 'premiumSubscribers'), where(documentId(), 'in', chunk)))
    )
  );

  snapshots.forEach((snapshot) => {
    snapshot.forEach((docSnapshot) => {
      const subscriptionStatus = String(docSnapshot.data()?.subscriptionStatus || '').trim().toLowerCase();

      if (PREMIUM_SUBSCRIPTION_STATUSES.has(subscriptionStatus)) {
        premiumUserIds.add(docSnapshot.id);
      }
    });
  });

  return premiumUserIds;
};
